import { render } from "./ModalCreateRole.vue?vue&type=template&id=04adc1a2&scoped=true"
import script from "./ModalCreateRole.vue?vue&type=script&lang=js"
export * from "./ModalCreateRole.vue?vue&type=script&lang=js"

import "./ModalCreateRole.vue?vue&type=style&index=0&id=04adc1a2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04adc1a2"]])

export default __exports__